var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-list',{staticStyle:{"column-count":"2"}},_vm._l((_vm.features),function(value,featureName){return _c('v-list-item',{key:featureName},[_c('v-list-item-content',[_c('v-switch',{attrs:{"label":featureName,"input-value":value},on:{"change":function($event){return _vm.updateFeature(featureName, $event)}}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }